<template>
  <div class="wrapper">
    <div class="movie-maker-wrapper" :class="{ hidden: !showMovieModal }" v-if="showMovieModal">

      <div id="movie-maker-modal" ref="clipMakerModal">
        <p class="modal-title" v-if="clipModalMode !== 'downloaded'">Clip Maker</p>
        <div class="modal-body" v-if="clipModalMode == 'creating'">
          <div class="modal-wrapper start-wrapper">
            <p class="modal-subtitle">Start Time</p>
            <div class="modal-group start-group">
              <button @click="decrementStartTime" :disabled="disableClipElements">-</button>
              <input type="datetime-local" v-model="startTime" :disabled="disableClipElements"
                  @click="openModalDatepicker('start')" ref="datetimePickerStart"
               v-if="isIos == false"/>
              <div class="datetime-wrapper" v-else>
                <input class="datetime-input" type="datetime-local" ref="datetimePickerStart"
                  v-model="startTime" :disabled="disableClipElements"
                  @click="openModalDatepicker('start')" />
                <div class="datetime-display" @click="openModalDatepicker('start')">
                  {{ formattedStartTime }}
                </div>
              </div>
              <button @click="incrementStartTime" :disabled="disableClipElements">+</button>
            </div>
          </div>
          <div class="modal-wrapper end-wrapper">
            <p class="modal-subtitle">End Time</p>
            <div class="modal-group end-group">
              <button @click="decrementEndTime" :disabled="disableClipElements">-</button>
              <input type="datetime-local" v-model="endTime" ref="datetimePickerEnd"
                :disabled="disableClipElements"  @click="openModalDatepicker('end')"
                v-if="isIos == false" />
              <div class="datetime-wrapper" v-else>
                <input class="datetime-input" type="datetime-local" ref="datetimePickerEnd"
                  v-model="endTime" :disabled="disableClipElements"
                  @click="openModalDatepicker('end')"/>
                <div class="datetime-display" @click="openModalDatepicker('end')">
                  {{ formattedEndTime }}
                </div>
              </div>
              <button @click="incrementEndTime" :disabled="disableClipElements">+</button>
            </div>
          </div>

        </div>

        <div class="modal-body modal-body-checkmark" v-else>
          <div class="checkmark-box">
            <div class="checkmark"></div>
            <h2>Download Complete</h2>
          </div>
        </div>

        <div class="modal-footer" v-if="clipModalMode == 'creating'">
          <button class="modal-close" @click="closeClipMaker">Cancel</button>
          <div class="split-button-wrapper">
            <button class="modal-accept split-main" @click="handleSplitButtonMain"
              :disabled="downloadingClip">
              <span :class="{ 'hide-download-text': this.downloadingClip }">
                {{ splitButtonText }}
              </span>
              <LoadingWheel class="download-indicator" v-if="downloadingClip" />
            </button>
            <button class="split-arrow" @click="toggleSplitDropdown" :disabled="downloadingClip">
              <span class="arrow-icon">&#9662;</span>
            </button>
            <div v-if="showSplitDropdown" class="split-dropdown">
              <div class="split-dropdown-item" @click="selectSplitOption('download')">
                Download Clip
               </div>
              <div v-if="isGoogleSignedIn" class="split-dropdown-item"
                @click="selectSplitOption('google')">
                Share to Google Drive
              </div>
              <div v-if="isMicrosoftSignedIn" class="split-dropdown-item"
                @click="selectSplitOption('microsoft')">
                Share to Microsoft OneDrive
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="movie-maker-modal-backdrop" @click="closeClipMaker">
      </div>

    </div>
    <div class="screenshot-wrapper" :class="{ hidden: !showScreenshotModal }"
      v-if="showScreenshotModal">

      <div id="screenshot-modal" ref="screenshotModal">
        <p class="modal-title" v-if="screenshotModalMode !== 'downloaded'">Creating Image</p>
        <div class="modal-body" v-if="screenshotModalMode == 'creating'">
          <LoadingWheel />
        </div>

        <div class="modal-body modal-body-checkmark" v-else>
          <div class="checkmark-box">
            <div class="checkmark"></div>
            <h2>Download Complete</h2>
          </div>
        </div>

        <div class="modal-footer" v-if="screenshotModalMode == 'creating'">
          <button class="modal-close" @click="handleCloseScreenshotModal">Cancel</button>
          <!-- <button class="modal-accept" @click="downloadScreenshot"
            :disabled="downloadingScreenshot">
            <span :class="{ 'hide-download-text': this.downloadingScreenshot }">
              Download Image
            </span>
            <LoadingWheel class="download-indicator" v-if="downloadingScreenshot" />
          </button> -->
        </div>

      </div>

      <div class="screenshot-modal-backdrop" @click="handleCloseScreenshotModal">
      </div>

    </div>

    <div class="google-share-wrapper" :class="{ hidden: !showGoogleShareModal }"
    v-if="showGoogleShareModal">
      <div id="google-share-modal" ref="googleShareModal">
        <p class="modal-title">Share Event</p>
        <div class="modal-body">
          <button class="google-share-btn" @click="shareToGoogle('google')">
            <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google" style="height:24px;vertical-align:middle;margin-right:8px;">
            Share to Google Drive
          </button>
          <button class="microsoft-share-btn" @click="shareToGoogle('microsoft')">
            <img src="~@/assets/Microsoft_logo.svg" alt="Microsoft"
              style="height:24px;vertical-align:middle;margin-right:8px;">
            Share to Microsoft OneDrive
          </button>
        </div>
        <div class="modal-footer">
          <button class="modal-close" @click="closeGoogleShareModal">Cancel</button>
        </div>
      </div>
      <div class="google-share-modal-backdrop" @click="closeGoogleShareModal"></div>
    </div>

    <transition name="slide">
      <DeviceStats ref="stats" v-if="showStats === true" :device="device"
        @requestStats="handleRequestStats" @close="showStats = false" />
    </transition>
    <div class="blackBlock">
      <div class="back backWhite" @click="$router.go(-1)"></div>
      <h2>{{ currentCamera.name | nameDecode }}</h2>
      <button class="statsBtn" @click="openStats" v-if="showStatsButton"></button>
      <router-link class="bgSvg" :to="{
        name: 'CameraSettings', params: {
          camera: currentCamera.id,
          device: this.$route.params.device
        }
      }"></router-link>
    </div>
    <div class="videoContainer">
      <LiveVideo ref="video" @statsResponse="handleStats" @connected="handleConnected"
        @clipStatus="handleClipStatus" v-if="currentCamera && device"
        :key="currentId" :camera="currentCamera"
        @next-camera="goNextCamera" @prev-camera="goPrevCamera"
        @sessionId="setSessionId" @openScreenshotModal="openScreenshotModal"
        @screenshotCompleted="handleScreenshotCompleted" :connect-delay-ms="1000"
        @dateChange="updateLastVideoDateEmitted" @filterChange="eventsEnabled = $event"
        @refreshEvents="refreshEvents">
        <TimelineScrubber
          v-if="showTimelineScrubber"
          :modelValue="scrubTs"
          :windowMinutes="60"
          :majorEveryMin="15"
          :minorEveryMin="5"
          :events="eventsReversed"
          @seek="seek"
        ></TimelineScrubber>
      </LiveVideo>

    </div>
    <div class="events">
      <events-list ref="eventsList" :key="currentId"
      @openClipMaker="openClipMaker" @createBlankClip="createBlankClip"
      @refreshEvents="refreshEvents" @shareEvent="openShareModal"
      :eventsEnabled="eventsEnabled"
      :videoDate="this.lastVideoDateEmitted" />
    </div>

    <!-- <div class="turnOff">
      <p>Turn camera off</p>
      <toggle />
    </div> -->
  </div>
</template>
<script>
import { Auth } from 'aws-amplify';
import LiveVideo from '@/components/LiveVideo.vue';
import DeviceStats from '@/components/DeviceStats.vue';
import { createMP4Clip } from '@/utils/messaging/MediaMakerMessages';
import DCv2 from '@/utils/DCv2';
import { toDatetimeLocal } from '@/utils/DateTime';
import EventsList from '../components/EventsList.vue';
import LoadingWheel from '../components/LoadingWheel.vue';
import TimelineScrubber from '../components/TimelineScrubber.vue';
// import Toggle from '../components/Toggle.vue';
// import awsInfo from '../../public/websocket';

export default {
  components: {
    LiveVideo, LoadingWheel, EventsList, DeviceStats, TimelineScrubber,
  },
  data() {
    return {
      showStats: false,
      connected: false,
      sendStatRequest: false,
      dcv2: null,
      showMovieModal: false,
      startTime: '',
      endTime: '',
      downloadingClip: false,
      movieClipStatus: 'not-created',
      movieClipTimer: -1,
      clipModalMode: 'creating',
      sessionId: '',
      filename: '',
      screenshotFilename: '',
      showScreenshotModal: false,
      screenshotModalMode: 'creating',
      downloadingScreenshot: false,
      firstInboxRequested: true,
      email: '',
      showGoogleShareModal: false,
      event: null,
      showSplitDropdown: false,
      splitButtonAction: 'download',
      splitButtonText: 'Download Clip',
      preferedShareOption: 'download',
      openedShareModel: false,
      scrubTs: Date.now(),
      lastVideoDateEmitted: 0,
      showTimelineScrubber: true,
      lastAutoScrollEvent: null,
      eventsEnabled: {},
    };
  },
  filters: {
    nameDecode(cameraName) {
      try {
        return decodeURIComponent(cameraName);
      } catch {
        return cameraName;
      }
    },
  },
  created() {
    if (this.currentCamera && this.device) {
      this.$store.dispatch('liveView', this.currentCamera.id);
      this.dcv2 = new DCv2(this.currentCamera.id);
    }
    window.get_file = this.get_file;
    window.delete_file = this.delete_file;
  },
  mounted() {
    this.scrubTs = this.liveHead;
    this.$store.dispatch('incrementAndSaveStat', ['cameraOpened']);
    Auth.currentUserInfo().then((user) => {
      this.email = user.attributes.email;
    });

    this.setShareOption();
  },
  beforeDestroy() {
    try {
      if (this.$refs.liveVideo) this.$refs.liveVideo.forceDisconnect();
    } catch (e) { /* Ignroe */ }
    if (this.dcv2 !== null) {
      if (this.dcv2.isConnected()) this.dcv2.disconnect();
    }
  },
  watch: {
    currentCamera() {
      if (this.currentCamera !== null) {
        this.$store.dispatch('liveView', this.currentCamera.id);
        this.dcv2 = new DCv2(this.currentCamera.id);
      }
    },
    checkingGoogleAuth(value) {
      if (value) return;
      if (this.openedShareModel) return;
      this.setShareOption();
    },
    liveHead() {
      this.scrubTs = this.liveHead;
    },
    scrubTs() {
      const evTs = this.currentEventStartTs ?? this.nextEventStartTs;
      if (evTs != null && evTs !== this.lastAutoScrollEvent) {
        this.lastAutoScrollEvent = evTs;
        this.$nextTick(() => this.$refs.eventsList.scrollToEvent(evTs));
      }
    },
  },
  computed: {
    currentCamera() {
      return this.$store.getters.camera(this.$route.params.camera);
    },
    currentId() {
      return this.currentCamera ? this.currentCamera.id : '-';
    },
    device() {
      return this.$store.getters.deviceId(this.$route.params.device);
    },
    disableClipElements() {
      return this.downloadingClip === true || this.movieClipStatus === 'ok' || this.movieClipStatus === 'complete';
    },
    clipTimesValid() {
      if (this.startTime === '' || this.startTime == null || this.startTime === undefined) return false;

      if (this.endTime === '' || this.endTime == null || this.endTime === undefined) return false;

      const start = Date.parse(this.startTime);
      const end = Date.parse(this.endTime);

      if (Number.isNaN(start) || Number.isNaN(end)) return false;

      const now = Date.now();

      if (now < start || now < end) return false;

      if (start > end || (end - 4000) < start) return false;

      return true;
    },
    filterTime() {
      return this.$store.getters.filterTime;
    },
    eventTo() {
      return this.$store.getters.eventTo;
    },
    isSoldelEmail() {
      return this.email.endsWith('@soldelgroup.com');
    },
    showStatsButton() {
      return this.connected === true && this.isSoldelEmail === true;
    },
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent);
    },
    formattedStartTime() {
      if (!this.startTime) return '';

      const date = new Date(this.startTime);
      const day = String(date.getDate()).padStart(2, '0');
      const month = date.toLocaleString('default', { month: 'short' }); // Format month as three-letter abbreviation
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${day} ${month} ${year} at ${hours}:${minutes}:${seconds}`;
    },

    formattedEndTime() {
      if (!this.endTime) return '';

      const date = new Date(this.endTime);
      const day = String(date.getDate()).padStart(2, '0');
      const month = date.toLocaleString('default', { month: 'short' }); // Format month as three-letter abbreviation
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${day} ${month} ${year} at ${hours}:${minutes}:${seconds}`;
    },

    checkingGoogleAuth() {
      return this.$store.getters['googleAuth/checkingGoogleAuth'];
    },

    isGoogleSignedIn() {
      return this.$store.getters['googleAuth/authenticatedWithGoogle'];
    },

    isMicrosoftSignedIn() {
      return this.$store.getters['googleAuth/authenticatedWithMicrosoft'];
    },
    liveHead() {
      if (this.lastVideoDateEmitted) return this.lastVideoDateEmitted;
      return Date.now();
    },
    currentEventStartTs() {
      const ts = Number(this.scrubTs);
      const events = this.eventsReversed || [];
      if (!Number.isFinite(ts) || !events.length) return null;
      // Find event where ts falls within [s, e] (inclusive)
      for (let i = 0; i < events.length; i += 1) {
        const e = events[i];
        if (
          Number.isFinite(e.s)
          && Number.isFinite(e.e)
          && e.s <= ts
          && ts <= e.e
        ) {
          return e.s;
        }
      }
      return null;
    },
    nextEventStartTs() {
      const ts = Number(this.scrubTs);
      const events = this.eventsReversed || [];
      if (!Number.isFinite(ts) || !events.length) return null;

      // Find the smallest start time strictly after ts
      let next = Infinity;
      for (let i = 0; i < events.length; i += 1) {
        const e = events[i];
        if (Number.isFinite(e.s) && e.s > ts && e.s < next) {
          next = e.s;
        }
      }
      return Number.isFinite(next) ? next : null;
    },
    eventsReversed() {
      const e = this.$store.getters.eventsReverse;
      if (e.length) return e.map((x) => x.data);
      return [];
    },
  },
  methods: {
    // --- Camera navigation within same device (wrap) ---
    goNextCamera() {
      this.changeCameraWithinGroup(+1);
    },
    goPrevCamera() {
      this.changeCameraWithinGroup(-1);
    },
    groupName(name) {
      if (name?.startsWith('-')) return name;
      const parts = name.split(/\s*-\s*|\s+\d+$|\s*\(\s*\d+\s*\)\s*$/);
      return parts[0] || name;
    },
    deviceOrderNumber(name) {
      const tail = name.match(/(?:\(|\s)(\d+)\s*\)?\s*$/);
      if (tail) return parseInt(tail[1], 10);
      const any = name.match(/(\d+)/g);
      if (any && any.length) return parseInt(any[any.length - 1], 10);
      return Number.POSITIVE_INFINITY; // unnumbered go to the end
    },
    normalizeCamerasForDevice(device) {
    // Support arrays of ids or camera objects
      const list = device?.cameras || [];
      const camIndex = this.$store.state.devices?.cameraIndex; // if you have a map
      const camList = this.$store.state.devices?.cameraList; // or a flat array
      return list.map((c) => (typeof c === 'object' ? c
        : (camIndex?.[c] || camList?.find((x) => x.id === c) || { id: c })));
    },

    // --- main change: traverse cameras across devices in the same group (with wrap) ---
    changeCameraWithinGroup(offset) {
      try {
        const { params, query, name } = this.$route;
        const routeCamId = String(params.camera);
        const routeDevId = String(params.device);

        const devicesAll = this.$store.state.devices?.deviceList || [];
        const currentDevice = devicesAll.find((d) => String(d.id) === routeDevId);
        if (!currentDevice) return;

        const group = this.groupName(currentDevice.name);

        const devicesInGroup = devicesAll
          .filter((d) => this.groupName(d.name) === group)
          .sort((a, b) => {
            const na = this.deviceOrderNumber(a.name);
            const nb = this.deviceOrderNumber(b.name);
            if (na !== nb) return na - nb;
            return a.name.localeCompare(b.name, 'en', { numeric: true });
          });

        if (!devicesInGroup.length) return;

        // Flatten (no for..of, no param mutation)
        const deviceCamPairs = devicesInGroup.reduce((arr, dev) => {
          const cams = this.normalizeCamerasForDevice(dev)
            .filter((cam) => cam && cam.id != null)
            .map((cam) => ({ cam, devId: dev.id }));
          return arr.concat(cams);
        }, []);

        if (!deviceCamPairs.length) return;

        const cameraSequence = deviceCamPairs.map((p) => p.cam);
        const camToDeviceId = deviceCamPairs.reduce(
          (obj, p) => ({ ...obj, [String(p.cam.id)]: p.devId }),
          Object.create(null),
        );

        const curIndex = Math.max(
          0,
          cameraSequence.findIndex((c) => String(c.id) === routeCamId),
        );
        const N = cameraSequence.length;
        const nextIndex = (curIndex + offset + N) % N;

        const nextCam = cameraSequence[nextIndex];
        const nextDevId = camToDeviceId[String(nextCam.id)];

        if (nextCam && nextDevId != null) {
          this.$router.replace({
            name,
            params: { device: nextDevId, camera: nextCam.id },
            query,
          });
        }
      } catch (_) { /* noop */ }
    },
    setSessionId(id) {
      this.sessionId = id;
    },
    openStats() {
      console.log('Open Stats');
      this.showStats = true;
      // if ('video' in this.$refs) this.$refs.video.getDeviceStats();
    },
    handleRequestStats() {
      if (this.connected) {
        if ('video' in this.$refs) this.$refs.video.getDeviceStats();
      } else {
        this.sendStatRequest = true;
      }
    },
    handleStats(data) {
      if ('stats' in this.$refs) this.$refs.stats.setStatsData(data);
    },
    handleConnected() {
      this.connected = true;
      if (this.sendStatRequest) {
        this.sendStatRequest = false;
        if ('video' in this.$refs) this.$refs.video.getDeviceStats();
      }
    },
    async get_file(filename) {
      await this.dcv2.spawn();
      await this.dcv2.doit('get', filename);
      await this.dcv2.doit('delete', filename);
      await this.dcv2.disconnect();
    },
    async delete_file(filename) {
      await this.dcv2.spawn();
      await this.dcv2.doit('delete', filename);
      await this.dcv2.disconnect();
    },
    async handleClipStatus(status) {
      if (this.movieClipStatus !== status) {
        this.movieClipStatus = status;
      }

      if (this.movieClipStatus === 'complete') {
        if (this.movieClipTimer !== -1) {
          this.stopMovieClipTimer();
          await this.get_file(`${this.filename}.mp4`);
          this.downloadingClip = false;
          this.clipModalMode = 'downloaded';
          setTimeout(this.closeClipMaker, 2500);
        }
      }
    },
    startMovieClipTimer() {
      this.movieClipTimer = setInterval(() => {
        const startDate = new Date(this.startTime);
        const endDate = new Date(this.endTime);

        const message = createMP4Clip(this.currentCamera.id, `${this.sessionId}.mp4`, startDate.getTime(), endDate.getTime());
        this.$refs.video.sendData(message);
      }, 1000);
    },
    stopMovieClipTimer() {
      clearInterval(this.movieClipTimer);
      this.movieClipTimer = -1;
    },
    openClipMaker(event) {
      try {
        if (this.$refs.video && this.$refs.video.exitFullscreenSafely) {
          this.$refs.video.exitFullscreenSafely();
        }
      } catch (_) { /* Ignore */ }

      const startDate = new Date(event.data.s);
      let endDate = new Date(event.data.e);

      if (endDate < (startDate.getTime() + 4000)) {
        endDate = new Date(startDate.getTime() + 4000);
      }

      this.startTime = toDatetimeLocal(startDate);
      this.endTime = toDatetimeLocal(endDate);

      this.clipModalMode = 'creating';
      this.showMovieModal = true;
    },
    closeClipMaker() {
      this.showMovieModal = false;
      this.startTime = '';
      this.endTime = '';
      this.downloadingClip = false;

      if (this.movieClipTimer !== -1) this.stopMovieClipTimer();

      this.movieClipStatus = 'not-created';
    },
    async createClip() {
      // eslint-disable-next-line eqeqeq
      if (this.movieClipStatus == 'complete') {
        this.downloadingClip = true;
        await this.get_file(`${this.filename}.mp4`);
        this.clipModalMode = 'downloaded';
        setTimeout(this.closeClipMaker, 2500);
        this.closeClipMaker();
        return;
      }

      if (!this.clipTimesValid) return;

      const start = Date.parse(this.startTime);
      const end = Date.parse(this.endTime);

      if (Number.isNaN(start) || Number.isNaN(end)) {
        return;
      }

      this.downloadingClip = true;
      const startDate = new Date(this.startTime);

      const year = startDate.getFullYear();
      const month = String(startDate.getMonth() + 1).padStart(2, '0');
      const day = String(startDate.getDate()).padStart(2, '0');
      const hours = String(startDate.getHours()).padStart(2, '0');
      const minutes = String(startDate.getMinutes()).padStart(2, '0');
      const seconds = String(startDate.getSeconds()).padStart(2, '0');

      this.filename = `${this.currentCamera.name.replaceAll(' ', '-')}-${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
      const message = createMP4Clip(this.currentCamera.id, `${this.filename}.mp4`, start, end);
      this.$refs.video.sendData(message);

      this.startMovieClipTimer();
    },

    async handleSplitButtonMain() {
      if (this.downloadingClip) return;
      if (this.splitButtonAction === 'download') {
        await this.createClip();
      } else if (this.splitButtonAction === 'google' || this.splitButtonAction === 'microsoft') {
        const times = {
          s: Date.parse(this.startTime),
          e: Date.parse(this.endTime),
        };
        this.shareToGoogle(this.splitButtonAction, times);
      }
      this.showSplitDropdown = false;
    },
    toggleSplitDropdown() {
      this.showSplitDropdown = !this.showSplitDropdown;
    },
    selectSplitOption(option) {
      if (option === 'download') {
        this.splitButtonText = 'Download Clip';
      } else if (option === 'google') {
        this.splitButtonText = 'Share to Google Drive';
      } else if (option === 'microsoft') {
        this.splitButtonText = 'Share to Microsoft OneDrive';
      }
      this.splitButtonAction = option;
      this.showSplitDropdown = false;
      localStorage.setItem('shareOption', option);
    },
    createBlankClip() {
      const currentDate = new Date().toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }).replace(',', '').replaceAll('/', '.');
      this.openClipMakerCurrentTime(currentDate);
    },
    openClipMakerCurrentTime(currentDate) {
      const date = this.parseDateTime(currentDate);
      const time = date.getTime();

      if (Date.now() - time < 5000) {
        const endDate = new Date(Date.now());
        const startDate = new Date(Date.now() - 10000);

        this.startTime = toDatetimeLocal(startDate);
        this.endTime = toDatetimeLocal(endDate);
      } else {
        // eslint-disable-next-line no-shadow
        const date = this.parseDateTime(currentDate);

        const startDate = new Date(date.getTime() - 5000);
        const endDate = new Date(date.getTime() + 5000);

        this.startTime = toDatetimeLocal(startDate);
        this.endTime = toDatetimeLocal(endDate);
      }

      this.clipModalMode = 'creating';
      this.showMovieModal = true;
    },
    decrementStartTime() {
      const date = new Date(this.startTime);
      date.setSeconds(date.getSeconds() - 1);
      this.startTime = toDatetimeLocal(date);
    },
    incrementStartTime() {
      const date = new Date(this.startTime);
      date.setSeconds(date.getSeconds() + 1);
      let endDate = new Date(this.endTime);

      if (endDate.getTime() - date.getTime() > 4000) {
        this.startTime = toDatetimeLocal(date);
        return;
      }

      endDate = new Date(date.getTime() + 4000);

      if (endDate.getTime() <= Date.now()) {
        this.startTime = toDatetimeLocal(date);
        this.endTime = toDatetimeLocal(endDate);
      }
    },
    decrementEndTime() {
      const startDate = new Date(this.startTime);

      const date = new Date(this.endTime);
      date.setSeconds(date.getSeconds() - 1);
      if (date.getTime() - startDate.getTime() >= 4000) {
        this.endTime = toDatetimeLocal(date);
      }
    },
    incrementEndTime() {
      const date = new Date(this.endTime);
      date.setSeconds(date.getSeconds() + 1);
      if (date.getTime() <= Date.now()) {
        this.endTime = toDatetimeLocal(date);
      }
    },
    parseDateTime(str) {
      const data = str.split(' ');
      const date = data[0].split('.').reverse().join('/');
      const time = data[1];
      return new Date(`${date} ${time} GMT`);
    },
    refreshEvents() {
      if ('video' in this.$refs) {
        const message = {
          topic: 'cmd/devices/tempest-dev/data-channel-relay',
          action: {
            command: 'qe',
            destination: `inbox-app/${this.currentCamera.id}`,
            data: {
              from: this.filterTime,
              to: this.eventTo !== null && this.eventTo !== undefined ? this.eventTo : Date.now(),
            },
          },
        };
        this.$refs.video.sendData(message);
        if (this.firstInboxRequested) {
          this.firstInboxRequested = false;
          this.$store.dispatch('incrementAndSaveStat', ['inboxRequested']);
        }
      }
    },
    openScreenshotModal(filename) {
      try {
        if (this.$refs.video && this.$refs.video.exitFullscreenSafely) {
          this.$refs.video.exitFullscreenSafely();
        }
      } catch (_) { /* Ignore */ }

      this.screenshotFilename = filename;
      this.showScreenshotModal = true;
      this.screenshotModalMode = 'creating';
    },
    closeScreenshotModal(cancelled) {
      if (cancelled) {
        if ('video' in this.$refs) {
          this.$refs.video.cancelScreenshot(this.screenshotFilename);
        }
      }
      this.showScreenshotModal = false;
      this.screenshotFilename = '';
    },
    handleCloseScreenshotModal() {
      this.closeScreenshotModal(true);
    },
    handleScreenshotCompleted() {
      this.closeScreenshotModal(false);
    },
    openShareModal(event) {
      try {
        if (this.$refs.video && this.$refs.video.exitFullscreenSafely) {
          this.$refs.video.exitFullscreenSafely();
        }
      } catch (_) { /* Ignore */ }

      console.log('[Debug] event:', event);
      if (this.openedShareModel === false) {
        this.openedShareModel = true;
      }
      this.showGoogleShareModal = true;
      this.event = event;
      this.$nextTick(() => {
        const modal = this.$refs.googleShareModal;
        if (modal && typeof modal.focus === 'function') {
          modal.focus();
        }
      });
    },
    closeGoogleShareModal() {
      this.showGoogleShareModal = false;
    },
    async shareToGoogle(platform, times) {
      console.log('[Debug] Sharing event to Google Drive:', this.event);

      const cameraId = this.currentCamera.id;
      const deviceId = this.device.id;

      const startTime = times.s;
      const endTime = times.e;

      const startDate = new Date(this.startTime);

      const year = startDate.getFullYear();
      const month = String(startDate.getMonth() + 1).padStart(2, '0');
      const day = String(startDate.getDate()).padStart(2, '0');
      const hours = String(startDate.getHours()).padStart(2, '0');
      const minutes = String(startDate.getMinutes()).padStart(2, '0');
      const seconds = String(startDate.getSeconds()).padStart(2, '0');

      const clipName = `${this.device.name.substr(0, 5)}-${this.currentCamera.name.replaceAll(' ', '-').substr(0, 10)}-${year}-${month}-${day}-${hours}-${minutes}-${seconds}.mp4`;

      const user = await Auth.currentAuthenticatedUser();
      const idToken = user.getSignInUserSession().getIdToken().getJwtToken();
      const accessToken = user.getSignInUserSession().getAccessToken().getJwtToken();

      fetch('https://tc3.dasvideolab.cloud:8000/clip/generate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          accessToken: idToken,
          deviceId,
          cameraId,
          startTime,
          endTime,
          clipName,
          platform,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('[Debug] Clip generation response:', data);
          this.closeClipMaker();
          this.$store.dispatch('addNotification', {
            type: 'green',
            title: `Sharing Event to ${platform === 'google' ? 'Google Drive' : 'Microsoft OneDrive'} process started!`,
            comment: '',
          });
        })
        .catch((error) => {
          console.error('[Error] Failed to share event:', error);
          this.$store.dispatch('addNotification', {
            type: 'red',
            title: 'Failed to Share Event',
            comment: '',
          });
        });
    },
    setShareOption() {
      const setting = localStorage.getItem('shareOption');

      if (['download', 'google', 'microsoft'].includes(setting)) {
        this.preferedShareOption = setting;
      } else {
        this.preferedShareOption = 'download';
      }

      if (this.checkingGoogleAuth) {
        this.splitButtonAction = 'download';
        this.splitButtonText = 'Download Clip';
        return;
      }

      if ((this.preferedShareOption === 'google' && this.isGoogleSignedIn) || (this.preferedShareOption === 'microsoft' && this.isMicrosoftSignedIn === false && this.isGoogleSignedIn === true)) {
        this.splitButtonAction = 'google';
        this.splitButtonText = 'Share to Google Drive';
        return;
      }

      if ((this.preferedShareOption === 'microsoft' && this.isMicrosoftSignedIn) || (this.preferedShareOption === 'google' && this.isGoogleSignedIn === false && this.isMicrosoftSignedIn === true)) {
        this.splitButtonAction = 'microsoft';
        this.splitButtonText = 'Share to Microsoft OneDrive';
        return;
      }

      this.splitButtonAction = 'download';
      this.splitButtonText = 'Download Clip';
    },
    openModalDatepicker(which) {
      if (which === 'start') this.$refs.datetimePickerStart.showPicker();
      if (which === 'end') this.$refs.datetimePickerEnd.showPicker();
    },
    updateLastVideoDateEmitted(ts) {
      this.lastVideoDateEmitted = ts;
    },
    seek(ts) {
      const seek = new Date(Math.min(ts, new Date().getTime()));
      const dayStart = Date.UTC(seek.getFullYear(), seek.getMonth(), seek.getDate(), 0, 0, 0);
      const dayEnd = dayStart + 86400000 - 1;

      if (new Date().getTime() - seek.getTime() < 1000) {
        this.$refs.video.switchToLiveview();
        return;
      }

      this.$store.dispatch('selectEvent', seek.getTime());
      setTimeout(() => {
        this.$store.dispatch('selectEvent', null);
        this.$store.dispatch('changeStartTime', dayStart);
        this.$store.dispatch('changeEndTime', dayEnd);
      }, 750);
    },
  },

  // UNCOMMENT WHEN SBC HAS FUNCTIONALITY FOR IT
  // methods: {
  //   cameraToggle(v) {
  //     if (v === false) {
  //       awsInfo.enableCamera(this.currentCamera.id);
  //     } else awsInfo.disableCamera(this.currentCamera.id);
  //   },
  // },
};

</script>

<style scoped>
/* ...existing code... */
.split-button-wrapper {
  display: flex;
  position: relative;
}
.split-main {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: 1px solid #ccc !important;
  z-index: 2;
}
.split-arrow {
  background: var(--success);
  color: var(--text);
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-left: none !important;
  padding: 0 16px;
  font-size: 18px;
  cursor: pointer;
  z-index: 2;
  user-select: none;
}
.arrow-icon {
  font-size: 18px;
  pointer-events: none;
}
.split-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: var(--surface);
  color: #272839;
  border-radius: 0 0 5px 5px;
  min-width: 200px;
  box-shadow: var(--shadow);
  z-index: 10;
}
.split-dropdown-item {
  padding: 12px 20px;
  cursor: pointer;
  transition: background 0.2s;
  color: var(--text);
}
.split-dropdown-item:hover {
  background: var(--surface);
}
/* ...existing code... */
</style>

<style scoped>
h2 {
  font-weight: 500;
  font-size: 20px;
}

.back {
  top: 0;
  left: 0;
  margin-left: 16px;
  position: relative;
}

.events {
  display: flex;
  width: 100vw;
  justify-content: center;
  flex: 1 1 20vh;
  position: relative;
}

.button {
  align-self: center;
  margin-top: 26px;
}

.turnOff {
  margin: 0 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wrapper {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  height: 100%;
}

.blackBlock {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.blackBlock a {
  width: 42px;
  height: 42px;
  margin-right: 16px;
  background-image: url("data:image/svg+xml,%3Csvg width='34' height='34' viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.8116 33H13.8114C13.632 33 13.4616 32.9403 13.3283 32.8363C13.1958 32.7329 13.1093 32.5935 13.0754 32.4446C13.0753 32.4443 13.0752 32.4439 13.0751 32.4435L12.3627 29.2437L12.2509 28.7418L11.7778 28.5407C10.8932 28.1647 10.055 27.6946 9.2785 27.1396L8.8753 26.8514L8.40177 26.9977L5.18302 27.9922L5.18265 27.9923C5.0133 28.0447 4.82991 28.0391 4.66489 27.9772C4.50027 27.9153 4.36907 27.8033 4.28769 27.6664L4.28694 27.6651L1.09428 22.314C1.09384 22.3133 1.09341 22.3125 1.09298 22.3118C1.01318 22.1749 0.984856 22.0193 1.00902 21.8688C1.03328 21.7177 1.11031 21.5734 1.23474 21.4619C1.23516 21.4615 1.23559 21.4611 1.23602 21.4608L3.73001 19.2533L4.11947 18.9086L4.06085 18.3918C3.9558 17.4656 3.9558 16.531 4.06085 15.6048L4.11955 15.0873L3.72915 14.7425L1.23564 12.5406C1.2352 12.5402 1.23476 12.5398 1.23431 12.5394C1.10973 12.4279 1.03261 12.2835 1.00835 12.1322C0.98414 11.9813 1.0127 11.8253 1.09301 11.6881C1.0933 11.6876 1.09359 11.6871 1.09389 11.6866L4.28057 6.3304L4.28068 6.33021C4.36206 6.19335 4.49326 6.08129 4.65788 6.01945C4.8229 5.95746 5.00629 5.95192 5.17564 6.00432L5.17601 6.00443L8.39476 6.99893L8.86865 7.14535L9.27198 6.85667C9.67013 6.5717 10.0827 6.30698 10.506 6.06837C10.9181 5.84425 11.3411 5.64079 11.7734 5.45946L12.2498 5.25961L12.3625 4.75537L13.0771 1.55713C13.0772 1.55692 13.0772 1.5567 13.0773 1.55649C13.1109 1.40745 13.1973 1.26783 13.3297 1.16424C13.4628 1.06014 13.6329 1.00028 13.8122 1H20.1889C20.3682 1.00028 20.5383 1.06013 20.6713 1.16424C20.8039 1.26798 20.8904 1.40785 20.924 1.55713L20.9241 1.55789L21.646 4.75899L21.7582 5.25646L22.2268 5.45778C22.6858 5.65503 23.1327 5.87515 23.563 6.11932L23.5668 6.12147C23.9673 6.34643 24.3558 6.59398 24.7306 6.86117L25.1335 7.14835L25.6062 7.00238L28.8264 6.00798C28.8264 6.00796 28.8264 6.00795 28.8265 6.00794C28.8265 6.00792 28.8266 6.0079 28.8267 6.00788C28.9958 5.95578 29.1789 5.96144 29.3437 6.02338C29.5081 6.0852 29.6392 6.19712 29.7205 6.3338C29.7205 6.33382 29.7205 6.33385 29.7206 6.33387L32.9067 11.6892C32.9071 11.6899 32.9075 11.6906 32.9079 11.6913C33.0682 11.9664 33.0176 12.3166 32.7664 12.5415C32.766 12.5418 32.7656 12.5421 32.7653 12.5425L30.2711 14.7501L29.8816 15.0948L29.9402 15.6116C30.0453 16.5378 30.0453 17.4724 29.9402 18.3986L29.8816 18.9154L30.2711 19.2601L32.7641 21.4667C32.7647 21.4672 32.7653 21.4678 32.7659 21.4683C33.0185 21.6957 33.0676 22.0448 32.9079 22.3189C32.9075 22.3196 32.9071 22.3203 32.9067 22.321L29.7205 27.6764L29.7204 27.6766C29.639 27.8135 29.5078 27.9255 29.3432 27.9874C29.1782 28.0493 28.9948 28.0549 28.8254 28.0025L28.8251 28.0024L25.6063 27.0079L25.1328 26.8616L24.7296 27.1498C23.9538 27.7043 23.1163 28.1737 22.2324 28.549L21.7611 28.7492L21.648 29.2486L20.9243 32.4429L20.9242 32.4435C20.8905 32.5927 20.804 32.7324 20.6714 32.836C20.5382 32.9401 20.368 32.9999 20.1887 33H13.8116ZM16.9935 9.2C14.8791 9.2 12.8454 10.0147 11.3413 11.474C9.83617 12.9343 8.98482 14.9214 8.98482 17C8.98482 19.0786 9.83617 21.0657 11.3413 22.526C12.8454 23.9853 14.8791 24.8 16.9935 24.8C19.108 24.8 21.1417 23.9853 22.6458 22.526C24.1509 21.0657 25.0022 19.0786 25.0022 17C25.0022 14.9214 24.1509 12.9343 22.6458 11.474C21.1417 10.0147 19.108 9.2 16.9935 9.2Z' fill='%23EAEBEC' stroke='%231F1C2A' stroke-width='2'/%3E%3C/svg%3E%0A");
}

.statsBtn {
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15 6C15 5.73478 15.1054 5.48043 15.2929 5.29289C15.4804 5.10536 15.7348 5 16 5H18C18.2652 5 18.5196 5.10536 18.7071 5.29289C18.8946 5.48043 19 5.73478 19 6V18H19.5C19.6326 18 19.7598 18.0527 19.8536 18.1464C19.9473 18.2402 20 18.3674 20 18.5C20 18.6326 19.9473 18.7598 19.8536 18.8536C19.7598 18.9473 19.6326 19 19.5 19H4.5C4.36739 19 4.24021 18.9473 4.14645 18.8536C4.05268 18.7598 4 18.6326 4 18.5C4 18.3674 4.05268 18.2402 4.14645 18.1464C4.24021 18.0527 4.36739 18 4.5 18H5V15C5 14.7348 5.10536 14.4804 5.29289 14.2929C5.48043 14.1054 5.73478 14 6 14H8C8.26522 14 8.51957 14.1054 8.70711 14.2929C8.89464 14.4804 9 14.7348 9 15V18H10V11C10 10.7348 10.1054 10.4804 10.2929 10.2929C10.4804 10.1054 10.7348 10 11 10H13C13.2652 10 13.5196 10.1054 13.7071 10.2929C13.8946 10.4804 14 10.7348 14 11V18H15V6Z' fill='white'/%3E%3C/svg%3E%0A");
  height: 40px;
  width: 40px;
  background-repeat: no-repeat;
  background-color: transparent;
  background-position: center;
  background-size: 100%;
}

video {
  width: 100%;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.3s;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(100%, 0);
}

.movie-maker-wrapper,
.screenshot-wrapper {
  position: fixed;
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
}

.movie-maker-modal-backdrop,
.screenshot-modal-backdrop {
  height: 100%;
  width: 100%;
  background-color: var(--modal-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}

.movie-maker-wrapper.hidden,
.screenshot-wrapper.hidden {
  display: none;
}

#movie-maker-modal {
  position: fixed;
  height: 350px;
  width: 600px;
  background-color: var(--surface);
  backdrop-filter: blur(3px);;
  border-radius: var(--border-radius);
  border: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
  max-width: calc(100% - 40px);
}

#movie-maker-modal:focus {
  outline: none;
}

#movie-maker-modal::backdrop {
  background-color: var(--modal-bg);
}

#screenshot-modal {
  position: fixed;
  height: 225px;
  width: 300px;
  background-color: var(--surface);
  border-radius: var(--border-radius);
  border: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;

}

.modal-title {
  color: var(--text);
  font-size: 1.625em;
  text-align: left;
  user-select: none;
}

.modal-subtitle {
  color: var(--text);
  font-size: 1.125em;
  margin-bottom: 10px;
  text-align: left;
  user-select: none;
}

.modal-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
}

.modal-group button {
  background-color: var(--surface-dark);
  height: 50px;
  border: 0;
  width: 80px;
  border-radius: var(--border-radius);
  color: var(--text);
  min-width: 40px;
  touch-action: manipulation;
}

.modal-group input[type=datetime-local],
.datetime-display {
  width: 350px;
  border-radius: var(--border-radius);
  background: none;
  border: none;
  font-size: 1rem;
  box-sizing: border-box;
}

.datetime-wrapper {
  position: relative;
  background: var(--surface-light);
  border-radius: var(--border-radius);
  border: var(--border);
  max-width: 350px;
  height: 50px;
  min-width: 50px;
}

.modal-group .datetime-input {
  background: transparent;
  color: transparent ;
  position: absolute ;
  user-select: none;
  top: 0;
  left: 0;
  min-width: 100%;
  max-width: 100%;
  height: 100%;
  z-index: -1;
}

.modal-group .datetime-input::selection {
  background: transparent!important;
  color: transparent!important;
}

.datetime-display {
  color: var(--text);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100%;
  max-width: 100%;
  height: 100%;
  user-select: none;
  padding-right: 20px;
}

.modal-footer button {
  padding: 15px 25px;

  border-radius: var(--border-radius);
  border: 0;
}

.modal-wrapper:first-child {
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-close {
  background: var(--error);
  color: var(--text);
  font-weight: bold;
  user-select: none;
}

.modal-accept {
  background: var(--success);
  color: var(--text);
  position: relative;
  font-weight: bold;
  user-select: none;
}

.movie-maker-wrapper {
  position: fixed;
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
}

.movie-maker-modal-backdrop {
  height: 100%;
  width: 100%;
  background-color: var(--modal-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}

.movie-maker-wrapper.hidden {
  display: none;
}

.hide-download-text {
  visibility: hidden;
}

.download-indicator {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.google-share-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(27, 27, 27, 0.3);
}
.google-share-wrapper.hidden {
  display: none;
}
#google-share-modal {
  background: #272839;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  padding: 32px 24px 24px 24px;
  min-width: 320px;
  max-width: 90vw;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.google-share-btn,
.microsoft-share-btn {
  display: flex;
  align-items: center;
  background: #4285f4;
  color: #fff;
  border: none;
  border-radius: var(--border-radius);
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 12px;
  transition: background 0.2s;
}
.google-share-btn:hover,
.microsoft-share-btn:hover {
  background: #3367d6;
}
.google-share-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(27, 27, 27, 0.3);
  z-index: -1;
}

#google-share-modal .modal-footer {
  margin-top: 20px;
}

#google-share-modal .modal-body {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.videoContainer {
  width: min(100%, 800px);
  max-width: 800px;
  max-height: 100%;
  min-width: 100px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex: 0 1 20vh;
}
</style>
